import { useEffect, useRef, useState } from "react";
import { pdfjs } from "react-pdf";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { BsArrowLeft, BsArrowRight } from "../../../assets/icons/vander";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const PdfViewer = ({ urlPdf, containerClass, maxHeight }) => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const prevPage = () => {
    setPageNumber((prev) => prev - 1);
  };

  const nextPage = () => {
    setPageNumber((prev) => prev + 1);
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const containerWidth = entry.contentRect.width;
        setWidth(containerWidth);
      }
    });

    if (containerRef.current) observer.observe(containerRef.current);
    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  //   useEffect(() => {
  //     console.log(width);
  //   }, [width]);

  return (
    <div className={containerClass}>
      <div
        ref={containerRef}
        style={{ maxHeight, overflow: "auto", width: "100%" }}
      >
        <div className="bg-gray-700 text-white p-3 sticky-top">
          <div className="d-flex align-items-center justify-content-center gap-3">
            <button
              className="btn btn-icon btn-pills btn-white"
              onClick={prevPage}
              disabled={pageNumber === 1}
            >
              <BsArrowLeft className="icons" />
            </button>
            <p className="mb-0">
              {pageNumber} / {numPages}
            </p>
            <button
              className="btn btn-icon btn-pills btn-white"
              onClick={nextPage}
              disabled={pageNumber === numPages}
            >
              <BsArrowRight className="icons" />
            </button>
          </div>
        </div>
        <Document
          loading={"Cargando documento"}
          file={urlPdf}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page
            className={"bg-gray-300 d-flex justify-content-center"}
            pageNumber={pageNumber}
            width={width - 20}
          />
        </Document>
      </div>
    </div>
  );
};
